import React from 'react';
import { styled, Tooltip, type TooltipProps, tooltipClasses } from '@mui/material';

const TableCellTooltip = styled(
  ({ className, loading, ...props }: TooltipProps & { loading: boolean }) => (
    <Tooltip
      disableInteractive
      disableFocusListener={loading}
      disableHoverListener={loading}
      disableTouchListener={loading}
      aria-disabled={loading}
      arrow
      classes={{ popper: className }}
      {...props}
    />
  ),
)(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    borderRadius: '2px',
  },
}));

export default TableCellTooltip;
